import { Component, OnInit, inject } from '@angular/core';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { Router } from '@angular/router';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { MyLoaderComponent } from '../core/components/my-loader/my-loader.component';
import { MatCard } from '@angular/material/card';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

@Component({
    selector: 'app-communication',
    templateUrl: './communication.component.html',
    styleUrls: ['./communication.component.scss'],
    imports: [MatToolbar, MatToolbarRow, MyLoaderComponent, MatCard, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator]
})
export class CommunicationComponent implements OnInit {
  private router = inject(Router);

  SAMPLE_DATA: any[] = [
    { subject: 'Problem with adding new order', user: 'x.yz', description: 'Description', status: 'No new messages' },
    { subject: 'Problem with adding new claim', user: 'x.yz', description: 'Description', status: '1 new message' },
    { subject: 'No available products', user: 'u.ser', description: 'Description', status: 'Closed' }
  ];

  dataSource = this.SAMPLE_DATA;
  displayedColumns: string[] = ['subject', 'user', 'status']

  ngOnInit(): void {
  }

  openConversation() {
    this.router.navigate(['/communication/conv'])
  }
}
